import { defineStore } from "pinia";
import { eventService, mobileRouteService } from "@/_services";

export const mobileRouteStore = defineStore("mobileRoute", {
  state: () => ({
    routeStops: null,
    error: null,
    finalizedStop: null,
    routeTasksByStop: null,
    incidentEvents: null,
  }),

  actions: {
    loadRouteStopsByPlan({ planId, vehicleId }) {
      this.error = null;
      this.routeStops = null;

      return mobileRouteService
        .loadRouteStopsByVehiclePlan(planId, vehicleId)
        .then((result) => {
          this.routeStops = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },

    finalizeRouteStop({ planId, routeStopId, mode, payload }) {
      this.error = null;
      this.finalizedStop = null;

      return mobileRouteService
        .finalizeRouteStop(planId, routeStopId, mode, payload)
        .then((result) => {
          this.finalizedStop = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },

    loadRouteTasksByStop(routeStopId) {
      this.error = null;
      return mobileRouteService
        .loadRouteTasksByStop(routeStopId)
        .then((result) => {
          this.routeTasksByStop = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },

    loadIncidentEvents() {
      this.error = null;
      return eventService
        .getAllEvents()
        .then((result) => {
          this.incidentEvents = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
